<template>
  <article class="m-card-element m-card-element-design-2 m-card-primary m-card-transition">

    <div class="m-card-element-info-data">
      <img
        v-if="satelite.imagen"
        :alt="satelite.titulo"
        :src="satelite.imagen"
      >
      <img
        v-else
        :alt="satelite.titulo"
        src="@/assets/img/ds2.png"
      >

      <!-- En lugar del rotulo fijo de Satelites va lo que distingue un plan de otro: sus creditos -->
      <h5 class="m-edition-billing-artificial-intelligence-card-credits">
        <i class="fas fa-brain"></i>
        {{ creditosTexto }}
      </h5>

      <h2 class="m-card-element-design-2-name">
        {{ satelite.titulo }}
      </h2>
    </div>

    <div class="m-card-element-info-state">
      <div class="m-card-element-info-state-of-access">
        <h3
          v-if="satelite.activo"
          class="text-color-success"
        >
          {{ $t('mEditionBillingArtificialIntelligence.card.activo') }}
        </h3>
        <h3
          v-else
          class="text-color-black-35"
        >
          {{ $t('mEditionBillingArtificialIntelligence.card.inactivo') }}
        </h3>
      </div>

      <span class="margin-left-auto font-size-small text-color-black-45">
        <i class="fas fa-eye font-size-small"></i>
        {{ $t('mEditionBillingArtificialIntelligence.card.detail') }}
      </span>
    </div>

  </article>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingArtificialIntelligenceCard',

  props: {
    // 'mensual' o 'creditos': la pestaña desde la que se listo el plan
    modalidad: String,
    satelite: Object
  },

  computed: {
    // "10.000 créditos por mes" o "10.000 créditos, pago único"
    creditosTexto () {
      return this.$t(`mEditionBillingArtificialIntelligence.card.creditos.${this.modalidad}`, {
        creditos: this.$utils.formatCredits(this.satelite.creditos)
      })
    }
  }
}
</script>
